__turbopack_context__.v({
  "actions": "CookieConsentBanner-module-scss-module__eQOMyq__actions",
  "banner": "CookieConsentBanner-module-scss-module__eQOMyq__banner",
  "body": "CookieConsentBanner-module-scss-module__eQOMyq__body",
  "button": "CookieConsentBanner-module-scss-module__eQOMyq__button",
  "copy": "CookieConsentBanner-module-scss-module__eQOMyq__copy",
  "description": "CookieConsentBanner-module-scss-module__eQOMyq__description",
  "icon": "CookieConsentBanner-module-scss-module__eQOMyq__icon",
  "iconWrap": "CookieConsentBanner-module-scss-module__eQOMyq__iconWrap",
  "inlineLink": "CookieConsentBanner-module-scss-module__eQOMyq__inlineLink",
  "intro": "CookieConsentBanner-module-scss-module__eQOMyq__intro",
  "slideUp": "CookieConsentBanner-module-scss-module__eQOMyq__slideUp",
  "title": "CookieConsentBanner-module-scss-module__eQOMyq__title",
  "wrapper": "CookieConsentBanner-module-scss-module__eQOMyq__wrapper",
});
